// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { DataProvider } from "./context/DataContext";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import "./fonts/loadFonts";

const theme = createTheme({
  palette: { primary: { main: "#d72329" } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DataProvider>
        <App />
      </DataProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
